import { useState, useEffect } from "react";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Table } from "reactstrap";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header from "components/Headers/Header.js";
import { format } from 'date-fns';
import { MapContainer, TileLayer, LayersControl, FeatureGroup, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";
import 'leaflet/dist/leaflet.css';
import Background from '../assets/img/product-device.png'

const Index = () => {
  const [loading1, setLoading1] = useState(true);
  const [sensorList, setSensorList] = useState([]);
  const [loading2, setLoading2] = useState(true);
  const [sensordata, setSensordata] = useState([]);
  const token = useSelector(state => state.userLogin.userInfo.token);
  const { t, i18n } = useTranslation();

  const is_first_time_visitor = useSelector(state => state.userLogin.userInfo.is_first_time_visitor);

  const [welcomeOpen, setWelcomeOpen] = useState(false);

  const toggleWelcome = async (e) => {
    setWelcomeOpen(false)

    const config = {
      headers: {
          Authorization: `Bearer ${token}`
      }
    };

    await axios.get(`${process.env.REACT_APP_BACKEND_API}/authentication/first-time-visitor/`, config);
  }

  useEffect(() => {
    if (is_first_time_visitor) {
      setWelcomeOpen(true);
    }
  }, [is_first_time_visitor]);


  useEffect(() => {
    const lang = localStorage.getItem('selectedLanguageAFS');
    if (lang) i18n.changeLanguage(lang);
  }, [i18n]);

  // fetch sensor list
  useEffect(() => {
    const fetchSensors = async () => {
      try {
        const config = {
          headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` }
        };
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/list/`, config);
        setSensorList(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading2(false);
      }
    };
    fetchSensors();
  }, [token]);

  // fetch dashboard data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = {
          headers: { 'Content-type': 'application/json', Authorization: `Bearer ${token}` }
        };
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/dashboard-data-visualization/`, config);
        setSensordata(data);
        console.log(data)
      } catch (err) {
        console.error(err);
      } finally {
        setLoading1(false);
      }
    };
    fetchData();
  }, [token]);

  // compute dynamic column width based on number of maps
  const mapCount = Object.values(sensordata).length;
  const colSize = mapCount > 0 ? Math.floor(12 / mapCount) : 12;

  const redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <Col xl="12">
            {loading1 ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner />
              </div>
            ) : (
              <>
                <Card className="shadow mb-5">
                  <CardHeader className="text-center">
                    <h3>{t('Sensors')}</h3>
                  </CardHeader>
                  <CardBody>
                    <Table responsive className="text-center">
                      <thead className="thead-light">
                        <tr>
                          <th>{t('ID Sensor')}</th>
                          <th>{t('Last Request')}</th>
                          <th>{t('Number of Request')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sensorList.map((s, i) => (
                          <tr key={i}>
                            <td>{s.id_sensor}</td>
                            <td>{format(new Date(s.last_request_at), 'PPpp')}</td>
                            <td>{s.number_of_request}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </>
            )}
          </Col>

          <Col xl="12">
            {loading1 ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner />
              </div>
            ) : Object.values(sensordata).length > 0 ? (
              <Row>
                {Object.values(sensordata).map((array, idx) => (
                  <Col key={idx} xl={colSize} className="mb-5">
                    <Card className="shadow">
                      <CardHeader className="text-center">
                        <h3>{t('Sensor Map -')} {array[0].id_sensor}</h3>
                      </CardHeader>
                      <CardBody>
                        <MapContainer
                          center={[array[0].y_coord, array[0].x_coord]}
                          zoom={17}
                          style={{ height: '500px', width: '100%' }}
                        >
                          <LayersControl position="topright">
                            <LayersControl.BaseLayer checked name="Satellite">
                              <TileLayer
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                attribution="&copy; Esri"
                              />
                            </LayersControl.BaseLayer>
                            <LayersControl.BaseLayer name="OpenStreetMap">
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution="&copy; OpenStreetMap contributors"
                              />
                            </LayersControl.BaseLayer>
                          </LayersControl>

                          {array.map((pt, j) => (
                            <FeatureGroup key={j}>
                              <Marker position={[pt.y_coord, pt.x_coord]} icon={redIcon}>
                                <Popup>
                                  <p>{t('Crop:')} {t(`translation:${pt.crop}`)}</p>
                                  <p>{t('Number of Grape:')} {pt.count}</p>
                                  <p>{t('Date Time of Data Acquisition:')} {format(new Date(pt.date), 'PPpp')}</p>
                                  {pt.image1 ? <img src={pt.image1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                  {pt.image1 ? <img src={pt.image2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                </Popup>
                              </Marker>
                            </FeatureGroup>
                          ))}
                        </MapContainer>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <Card className="shadow mt-5 text-center">
                <CardHeader><h3>{t('No Data Available')}</h3></CardHeader>
                <CardBody>{t('No Data Available')}</CardBody>
              </Card>
            )}
          </Col>
        </Row>
        <Modal 
          isOpen={welcomeOpen} 
          toggle={toggleWelcome} 
          centered 
          fade
          backdrop="static"
          keyboard={false}>
          <ModalHeader toggle={toggleWelcome}>
            {t("Welcome to FruitKount")}
          </ModalHeader>

          <ModalBody>
              <img
                src={Background}
                alt="Welcome"
                className="img-fluid mb-3 d-block mx-auto"
                style={{ maxHeight: "200px" }}
              />
            <p>{t("Let's map your yield with the most advanced AI System 🤖")}</p>
            <p>{t("The system is based on european patent")}</p>
            <p>{t("We have added some samples data to your account, in order to show you the functionality of the system")}</p>
            <p>{t("You can delete them at any time")}</p>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={toggleWelcome}>
              {t("Let's Get Started")}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default Index;
